export default "__VITE_ASSET__DUwqYszA__";